<div class="content-block">
   <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h2 class="content-block">Dipendente > <b>{{dipendente?.nominativo}}</b></h2>
                <div class="d-flex gap-4" >
                  <dx-button stylingMode="contained" class="mr-3" text="Torna alla dashboard del dipendente" icon="home" type="success" (onClick)="goToDashboardDipendente()"> </dx-button>

                </div>
            </div>
        </div>
      </div> 
  
    <div class="row">
  
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">

            <div class="nav-tabs-custom">
              <ul class="nav nav-pills"><!-- data-bs-toggle -->
                <li class="nav-item"><a class="nav-link active" href="#datidipendente"data-bs-toggle="tab">DATI DIPENDENTE</a></li>
                <li class="nav-item"><a class="nav-link" href="#allegati" data-bs-toggle="tab">ALLEGATI</a></li>
                
                <li class="nav-item"><a class="nav-link" href="#articoliconsegnati" data-bs-toggle="tab">ARTICOLI ASSEGNATI</a></li>   
                <li class="nav-item"><a class="nav-link" href="#articoliprevisti" data-bs-toggle="tab">ARTICOLI PREVISTI</a></li>  
                <li class="nav-item"><a class="nav-link" href="#scadenze" data-bs-toggle="tab">SCADENZA</a></li>      
              </ul>
            </div>
         
            <div class="tab-content">
  
                <div class="tab-pane active" id="datidipendente" >
                    <app-form-dipendente  [idDipendente]="idDipendente"></app-form-dipendente>                
                </div> <!-- /.tab-pane -->

                 <div class="tab-pane" id="allegati">
                    <app-grid-allegati-dipendente [dipendente]="dipendente"></app-grid-allegati-dipendente>
                 </div>

                 <div class="tab-pane" id="articoliconsegnati">
                  <app-articoli-consegnati [idDipendente]="idDipendente" [idArticolo]="0" [filterEnable]="true" [bConsultazione]="false"></app-articoli-consegnati>
                 </div>

                 <div class="tab-pane" id="articoliprevisti">
                  <app-gestione-articoli-previsti [idDipendente]="idDipendente" [idMansione]="dipendente?.idMansione"></app-gestione-articoli-previsti>
                 </div>

                 <div class="tab-pane" id="scadenze">
                     <app-grid-scadenze-dipendenti [idDipendente]="idDipendente"></app-grid-scadenze-dipendenti>   
                 </div>

            </div>
          </div>
        </div>
  
      </div>
  
    </div>
  
  </div>

